import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const updateTicket = createAsyncThunk(
  'ticket/updateTicket',
  async ({ ticketId, updateData }, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      console.log('loginToken', loginToken);
      const authToken = loginToken?.response?.token;
      const businessId = loginToken?.response?.user?.business_id;
      console.log('updateData', updateData);
      const response = await axios.patch(
        `${ROOT_URL}/ticket/${ticketId}/business/${businessId}`,
        updateData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false,
};

const updateTicketSlice = createSlice({
  name: 'updateTicket',
  initialState,
  reducers: {
    resetUpdateState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateTicket.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateTicket.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(updateTicket.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetUpdateState } = updateTicketSlice.actions;
export default updateTicketSlice.reducer; 